module.exports = __webpack_public_path__ + "img/value.7469f35b.jpg";